import { render, staticRenderFns } from "./ExchangeExhibitionDialog.vue?vue&type=template&id=24641edf&scoped=true"
import script from "./ExchangeExhibitionDialog.vue?vue&type=script&lang=js"
export * from "./ExchangeExhibitionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24641edf",
  null
  
)

export default component.exports